import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tSMTP Importer Logs\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "input-group-btn" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_12 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_13 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */);
const _hoisted_19 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_20 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_21 = { class: "float-end" };
const _hoisted_22 = { class: "float-end hidden-xs record-count" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12" };
const _hoisted_24 = { class: "card bg-white data-grid smtp-importer-logs-grid detached overflow-x-auto" };
const _hoisted_25 = {
    id: "logsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_26 = { class: "date-time-column" };
const _hoisted_27 = { class: "hidden-sm" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "hidden-sm" };
const _hoisted_30 = { class: "clearfix visible-sm" };
const _hoisted_31 = { class: "hidden-sm" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center hidden-sm",
    colspan: "13"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("td", { class: "text-center visible-sm" }, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_35 = { class: "clearfix" };
const _hoisted_36 = { key: 0 };
const _hoisted_37 = { class: "d-flex align-items-center gap-2" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("h2", null, "Messages", -1 /* HOISTED */);
const _hoisted_39 = { class: "col-xs-12 col-sm-12" };
const _hoisted_40 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_41 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tType\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tMessage\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tException\r\n\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_43 = { key: 0 };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "3"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_45 = [
    _hoisted_44
];
const _hoisted_46 = { key: 1 };
const _hoisted_47 = { class: "d-flex align-items-center gap-2" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("h2", null, "Files Attached", -1 /* HOISTED */);
const _hoisted_49 = { class: "col-xs-12 col-sm-12" };
const _hoisted_50 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_51 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tStatus\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAttached File Name\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tFile Name\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tErrors\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tWarnings\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSystems\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSnapshots\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tCharges\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tDischarges\r\n\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_53 = ["onClick"];
const _hoisted_54 = { key: 0 };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "9"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_56 = [
    _hoisted_55
];
const _hoisted_57 = { key: 2 };
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("h2", null, "Emails", -1 /* HOISTED */);
const _hoisted_59 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_60 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_61 = { class: "float-end" };
const _hoisted_62 = { class: "float-end hidden-xs record-count" };
const _hoisted_63 = { class: "col-xs-12 col-sm-12" };
const _hoisted_64 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_65 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_66 = { class: "date-time-column" };
const _hoisted_67 = ["onClick"];
const _hoisted_68 = { key: 0 };
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "7"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_70 = [
    _hoisted_69
];
const _hoisted_71 = { class: "float-end float-start-sm" };
const _hoisted_72 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_8, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_10)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_11, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedFrom,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.whenCreatedFrom) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _hoisted_15
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedTo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.whenCreatedTo) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _hoisted_17,
                                                    _createTextVNode(),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createTextVNode(),
                _hoisted_18,
                _createTextVNode(),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("table", _hoisted_25, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_26, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'whenCreated', title: 'Time', visible: true }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_27, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'status', title: 'Status' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: "pointer",
                                        onClick: ($event) => (_ctx.view(item))
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatTimeString(item.whenCreated)), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.getSMTPImporterStatusText(item.status)), 1 /* TEXT */)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.getSMTPImporterStatusText(item.status)), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_28));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                                        _hoisted_33,
                                        _createTextVNode(),
                                        _hoisted_34
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "smtp-importer-log-details-popup",
            modelValue: _ctx.viewingLogDetails,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.viewingLogDetails) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tLog Details\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_72,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                            (_ctx.showMessagesModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("i", {
                                            class: "fa fa-arrow-left font16 pointer",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.selectedFile = null))
                                        }),
                                        _createTextVNode(),
                                        _hoisted_38
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("table", _hoisted_41, [
                                                _hoisted_42,
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMessagesToDisplay(), (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", null, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getMesssageTypeText(item.messageType)), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.message), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.errorException), 1 /* TEXT */)
                                                        ]));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.getMessagesToDisplay().length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_43, _hoisted_45))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.showFilesModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("i", {
                                            class: "fa fa-arrow-left font16 pointer",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.selectedEmail = null))
                                        }),
                                        _createTextVNode(),
                                        _hoisted_48
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("table", _hoisted_51, [
                                                _hoisted_52,
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilesToDisplay(), (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            class: "pointer",
                                                            onClick: _withModifiers(($event) => (_ctx.selectFile(item)), ["stop"])
                                                        }, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getStatusText(item.status)), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.attachedFileName), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.fileName), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithError), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithWarning), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfSystemsImported), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfSnapshotsImported), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfChargeImported), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfDischargeImported), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_53));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.getFilesToDisplay().length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_54, _hoisted_56))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.showEmailsModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createTextVNode(),
                                    (_ctx.searchAttempted)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("div", _hoisted_61, [
                                                    _createVNode(_component_b_pagination, {
                                                        class: "float-end",
                                                        modelValue: _ctx.detailsQuery.pageNo,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.detailsQuery.pageNo) = $event)),
                                                        "per-page": _ctx.detailsQuery.pageSize,
                                                        "total-rows": _ctx.logDetails.emails.recordCount,
                                                        "hide-ellipsis": true,
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_62, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.logDetails.emails.recordCount), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_63, [
                                        _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("table", _hoisted_65, [
                                                _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", _hoisted_66, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'messageDateTime', title: 'Time', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'status', title: 'Status', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'from', title: 'From', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'subject', title: 'Subject', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesAttached', title: 'Attachments', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesWithError', title: 'Errors', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesWithWarning', title: 'Warnings', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ])
                                                    ])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logDetails.emails.records, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            class: "pointer",
                                                            onClick: ($event) => (_ctx.selectEmail(item))
                                                        }, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.formatTimeString(item.messageDateTime)), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getStatusText(item.status)), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.from), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.subject), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesAttached), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithError), 1 /* TEXT */),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithWarning), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_67));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.logDetails.emails.length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_68, _hoisted_70))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.loading,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
